import { Component, ViewChild } from '@angular/core';
import { Router} from '@angular/router';
import {GridBaseCase} from './grid.base.case';
import { BaseCase } from "src/app/basecase";
import { CommonService } from 'src/service/common.service';
import { QcCustomerDetailComponent } from '../qc/qc-customer-detail/qc-customer-detail.component';
import {MzApprovalPersonComponent} from 'src/app/components/grid/mz-approval-person/mz-approval-person.component';
import{MzScheduleApprovalComponent} from 'src/app/components/grid/mz-schedule-approval/mz-schedule-approval.component';
@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent extends GridBaseCase {
//判断当前template.content.configName是否存在
  isgridViewConfigName:boolean = false;
  @ViewChild("QcCustomerDetail") QcCustomerDetail: QcCustomerDetailComponent;
  @ViewChild("approvalperson") approvalperson: MzApprovalPersonComponent;
  @ViewChild("scheduleapproval") scheduleapproval: MzScheduleApprovalComponent;
  
  constructor(private router:Router,
    public baseService:BaseCase,
    private com: CommonService,
    )
   {
     super();
   }
   ngOnInit(){

   }
  getAction(){
    const date=new Date();
    this.com.Go("/tabs/list/"+date.getSeconds());
   }
   appGridSubmit(param,type:any,index:number=0) {
    let that = this;
    // debugger;
    switch (param) {
      case 'customer':
        that.QcCustomerDetail.EventSubmitClick();
        break;
        case 'approvalperson'://排版审批
        
         if(index==0){
          that.approvalperson.EventSubmit(type);
         }else if(index==3){
          console.log(that.baseService.FixedSubmitBtn);
          that.approvalperson.EventCheckAllToggle();
         }
         else{
           that.approvalperson.EventApproveSubmit();
         }
          break;
          case 'scheduleapproval':
            if(index==0){
              that.scheduleapproval.EventClick(type);
             }else if(index==3){
              that.scheduleapproval.EventCheckAllToggle();
             }
             else{
               that.scheduleapproval.EventApproveClick();
             }

    }
  }
}
